import type { JSX } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { PlaceField } from 'src/app/shared/components/googlePlaces';

import { useLocation } from './hooks/useLocation';

export function Location(): JSX.Element | null {
	const { translate } = useI18n();
	const { data, actions } = useLocation();

	if (data.geoReach !== 'local') return null;

	return (
		<Box
			id="petition_location"
			className="-mt-4"
			sx={{
				'label span': {
					lineHeight: '1.25rem',
					fontSize: '0.875rem',
					fontWeight: '400',
				},
				'#petition-place': { height: '52px !important' },
				'#petition-place + div': { marginTop: '11px !important' },
			}}
		>
			<PlaceField
				label={translate('corgi.petition.edit.petition_data.location.title')}
				geoScope={data.geoReach}
				onSelect={actions.onSelect}
				defaultPlaceValue={data.place}
				error={data.error ? translate(data.error) : null}
			/>
		</Box>
	);
}
